import { createDsManagedModalController } from '../../../../../shared-ui/ds/behaviorAdapters.js';
import { withSettingsPresentationMode } from './settingsPresentationMode.js';

export function createSettingsModalController(options = {}) {
  return createDsManagedModalController(withSettingsPresentationMode(options));
}
